import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ConnectedPositioningStrategy, HorizontalAlignment, VerticalAlignment, NoOpScrollStrategy } from 'igniteui-angular';

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HamburgerMenuComponent implements OnInit {
  @Input() dropdownList = [];
  @Input() dropdownItemsIcon = [];
  @Input() dropdownEnabled = false;
  @Input() dataPack;
  @Output() onDropdownSelection = new EventEmitter<any>();

  @Input() overlaySettings = {
    positionStrategy: new ConnectedPositioningStrategy({
        horizontalDirection: HorizontalAlignment.Left,
        horizontalStartPoint: HorizontalAlignment.Right,
        verticalStartPoint: VerticalAlignment.Bottom
    }),
    scrollStrategy: new NoOpScrollStrategy()
};
  
  constructor() { }

  ngOnInit(): void {
    (this.dataPack);
  }

  onDropdownItemSelected(event){
    if(!event) return;
    const statusIndex = event?.newSelection?.index;
    if(statusIndex === undefined) return;

    this.dataPack.actions[statusIndex]();
  }

}
